import { Outlet, createFileRoute } from '@tanstack/react-router';
import { VStack } from '@/components/Layout';
import { BusinessPartnerProfileHeader } from './_layout/_index/-components/BusinessPartnerProfileHeader';
export const Route = createFileRoute('/_staff/business-partner/$id/_layout')({
  component: RouteComponent
});
function RouteComponent() {
  return <VStack className="gap-0">
      <BusinessPartnerProfileHeader />
      <Outlet />
    </VStack>;
}